<div class="sb-live-scoreboard-sets" [ngClass]="'background-' + match?.SportHandle">
  <div class="sb-live-scoreboard-sets--container">
    <div class="sb-live-scoreboard-sets--header">
      <span class="sb-live-scoreboard--subtitle">{{ matchPeriod }} {{ matchTime }}</span>

      <ng-container *ngIf="sport === 'american_football' && matchPeriod !== 'descanso'">
        <span class="sb-live-scoreboard--subtitle color-muted">
          {{ match?.Try }}&deg; &amp; {{ match?.Yards }}&deg;
        </span>
      </ng-container>
    </div>

    <div class="sb-live-scoreboard-sets--info">
      <span class="sb-live-scoreboard--title color-light">
        {{ (match?.ParticipantHome === null || match?.ParticipantHome === undefined) ? 'null' : (match?.ParticipantHome | sportsTitleCase) }}
      </span>
      <span class="sb-live-scoreboard--title color-light">
        {{ (match?.ParticipantAway === null || match?.ParticipantAway === undefined) ? 'null' : (match?.ParticipantAway | sportsTitleCase) }}
      </span>
    </div>

    <div class="sb-live-scoreboard-sets--score">
      <div
        *ngIf="service"
        [hidden]="match?.PeriodName === 'Descanso'"
        class="sb-live-scoreboard-sets--column has-service-dots"
      >
        <i
          class="sb-scoreboard-dot"
          [ngClass]="{
            'sb-button--animation': match?.HomeService || match?.HomeAttacking,
            'background-color-primary': match?.HomeService && match?.SportHandle === 'tennis',
            'background-color-white': match?.HomeService && match?.SportHandle !== 'tennis'
          }"
        ></i>
        <i
          class="sb-scoreboard-dot"
          [ngClass]="{
            'sb-button--animation': !match?.HomeService || !match?.HomeAttacking,
            'background-color-primary': !match?.HomeService && match?.SportHandle === 'tennis',
            'background-color-white': !match?.HomeService && match?.SportHandle !== 'tennis'
        }"
        ></i>
      </div>

      <div *ngIf="attack" class="sb-live-scoreboard-sets--column is-column-attack">
        <i
          class="sb-live-scoreboard--legend codere-icon icon-american_football"
          [ngClass]="{
          'sb-button--animation': match?.HomeAttacking,
          'color-light': match?.HomeAttacking
        }"
        ></i>
        <i
          class="sb-live-scoreboard--legend codere-icon icon-american_football"
          [ngClass]="{
          'sb-button--animation': !match?.HomeAttacking,
          'color-light': !match?.HomeAttacking
        }"
        ></i>
      </div>

      <div *ngIf="points" class="sb-live-scoreboard-sets--column is-column-points">
        <span class="sb-live-scoreboard--number color-grey color-light">{{ match?.ResultHome }}</span>
        <span class="sb-live-scoreboard--number color-light">{{ match?.ResultAway }}</span>
      </div>

      <div *ngFor="let set of match?.Sets; let last = last; let first = first" class="sb-live-scoreboard-sets--column">
        <span
          *ngIf="match?.SportHandle === 'snooker'"
          class="sb-live-scoreboard-sets--legend sb-live-scoreboard-sets--title color-light"
          >180</span
        >
        <span
          *ngFor="let game of set; let i = index"
          [ngClass]="setGameState(game, set, last, i)"
          class="sb-live-scoreboard--number"
          >{{ game }}</span
        >
      </div>

      <ng-container *ngIf="match?.Quarters?.length">
        <div
          class="sb-live-scoreboard-sets--column"
          *ngFor="let quarter of match?.Quarters; let index = index; let last = last"
          [ngClass]="{
          'color-light': currentPeriod === index + 1 && !halfTime,
          'color-score': currentPeriod !== index + 1 || halfTime
          }"
        >
          <span class="sb-live-scoreboard--number" *ngFor="let result of quarter">{{ result }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="match?.Periods?.length">
        <div
          class="sb-live-scoreboard-sets--column"
          *ngFor="let period of match?.Periods; let index = index; let last = last"
          [ngClass]="{
              'color-light': currentPeriod === index + 1 && !halfTime,
              'color-score': currentPeriod !== index + 1 || halfTime }"
        >
          <span class="sb-live-scoreboard--number" *ngFor="let result of period"> {{ result }} </span>
        </div>
      </ng-container>

      <div *ngIf="yellowCards" class="sb-live-scoreboard-sets--column">
        <i class="sb-live-scoreboard--legend has-yellow-card"></i>
        <span class="sb-live-scoreboard--number color-light"> {{ match?.YellowCardsHome }} </span>
        <span class="sb-live-scoreboard--number color-light"> {{ match?.YellowCardsAway }} </span>
      </div>

      <div *ngIf="redCards" class="sb-live-scoreboard-sets--column">
        <i class="sb-live-scoreboard--legend has-red-card"></i>
        <span class="sb-live-scoreboard--number color-light"> {{ match?.RedCardsHome }} </span>
        <span class="sb-live-scoreboard--number color-light"> {{ match?.RedCardsAway }} </span>
      </div>

      <div *ngIf="corners" class="sb-live-scoreboard-sets--column">
        <i class="sb-live-scoreboard--legend color-light codere-icon icon-Corner"></i>
        <span class="sb-live-scoreboard--number color-light"> {{ match?.homeCorners }} </span>
        <span class="sb-live-scoreboard--number color-light"> {{ match?.awayCorners }} </span>
      </div>

      <div *ngIf="totalScore" class="sb-live-scoreboard-sets--column has-background">
        <span
          *ngIf="match?.SportHandle === 'snooker'"
          class="sb-live-scoreboard-sets--legend sb-live-scoreboard-sets--title color-light"
          >L</span
        >
        <i
          *ngIf="match?.SportHandle === 'soccer'"
          class="sb-live-scoreboard--legend color-light codere-icon icon-soccer"
        ></i>

        <span class="sb-live-scoreboard--number color-grey color-yellow"> {{ match?.ResultHome }} </span>
        <span class="sb-live-scoreboard--number color-grey color-yellow"> {{ match?.ResultAway }} </span>
      </div>
    </div>
  </div>
</div>
